import {getCheckoutProfileDocumentCellKey} from '@dms/api/sales';

import type {CheckoutProfileIssue} from '../../../utils/getCheckoutProfileIssueMessage';

export function focusCheckoutProfileIssue(issue: CheckoutProfileIssue) {
  const documentName = issue.documentType
    ? `documents.${getCheckoutProfileDocumentCellKey({saleRegime: issue.saleRegime ?? null, documentType: issue.documentType, paymentMethod: issue.paymentMethod ?? null})}.${issue.field?.split('.').at(-1) ?? 'restrictSeries'}`
    : undefined;

  const name = documentName ?? issue.field;
  let element = name
    ? Array.from(document.getElementsByName(name)).find((item) => item instanceof HTMLElement)
    : document.getElementById(`checkout-feedback-${issue.tab?.toLowerCase()}`);

  element ??= document.getElementById(`checkout-focus-${name}`);

  if (!element && name?.endsWith('.defaultMethod')) {
    element = Array.from(document.querySelectorAll<HTMLElement>('[id^="checkout-focus-"]')).find(
      (item) =>
        item.id.startsWith(`checkout-focus-${name}.`) &&
        !!item.querySelector('input:not(:disabled)')
    );
  }

  element ??= document.getElementById(`checkout-feedback-${issue.tab?.toLowerCase()}`);

  if (!(element instanceof HTMLElement)) {
    return false;
  }

  if (element instanceof HTMLInputElement && element.type === 'hidden') {
    let parent = element.parentElement;
    while (parent && !parent.querySelector('[role="combobox"]')) {
      parent = parent.parentElement;
    }

    element = parent?.querySelector<HTMLElement>('[role="combobox"]') ?? element;
  }

  if (!(element instanceof HTMLInputElement) && !(element instanceof HTMLButtonElement)) {
    element =
      element.querySelector<HTMLElement>(
        'input:not([type="hidden"]):not(:disabled), button:not(:disabled)'
      ) ?? element;
  }

  element.scrollIntoView?.({block: 'center'});
  element.focus();

  return true;
}
